"use strict";
/*
 * Created on 07 05 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SelloutTypeWithItemCounts_1 = require("../model/SelloutTypeWithItemCounts");

var SelloutTypeWithItemCountsConverter_1 = require("./SelloutTypeWithItemCountsConverter");
/**
 * Implementation of {@link SelloutTypeWithItemCountsConverter}
 *
 * @author JMe
 */


var SelloutTypeWithItemCountsConverterImpl =
/*#__PURE__*/
function (_SelloutTypeWithItemC) {
  _inherits(SelloutTypeWithItemCountsConverterImpl, _SelloutTypeWithItemC);

  function SelloutTypeWithItemCountsConverterImpl() {
    _classCallCheck(this, SelloutTypeWithItemCountsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTypeWithItemCountsConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutTypeWithItemCountsConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        type: source.type,
        itemCount: source.itemCount,
        productCount: source.productCount,
        siteIds: conversions.asObjectArray(source, 'siteIds', function (v) {
          return conversions.toDocumentReferenceId(v);
        })
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutTypeWithItemCounts_1.SelloutTypeWithItemCounts(SelloutTypeWithItemCounts_1.SelloutTypeWithItemCounts.schema.type.valueOfField(source), SelloutTypeWithItemCounts_1.SelloutTypeWithItemCounts.schema.itemCount.valueOfField(source), SelloutTypeWithItemCounts_1.SelloutTypeWithItemCounts.schema.productCount.valueOfField(source), SelloutTypeWithItemCounts_1.SelloutTypeWithItemCounts.schema.siteIds.valueOf(conversions.asObjectSet(source, 'siteIds', function (v) {
        return conversions.toClassReferenceId(v);
      })));
    }
  }]);

  return SelloutTypeWithItemCountsConverterImpl;
}(SelloutTypeWithItemCountsConverter_1.SelloutTypeWithItemCountsConverter);

exports.SelloutTypeWithItemCountsConverterImpl = SelloutTypeWithItemCountsConverterImpl;